import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CustomerPriorityService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customerpriority`;

  constructor(private http: HttpClient) { }

  getNewAssignment(partnerUserId: number): Observable<number> {
    const params = new HttpParams().set('partnerUserId', partnerUserId);

    return this.http.get<number>(`${this.baseUrl}/GetNewAssignment`, { params: params });
  }

  getCurrentAssignment(userId: number): Observable<Boo.Objects.CustomerPriorityAssignment> {
    const params = new HttpParams().set('userId', userId);

    return this.http.get<Boo.Objects.CustomerPriorityAssignment>(`${this.baseUrl}/GetCurrentAssignment`, { params: params });
  }

  getCurrentAssignments(): Observable<Boo.Objects.CustomerPriorityAssignment[]> {
    return this.http.get<Boo.Objects.CustomerPriorityAssignment[]>(`${this.baseUrl}/GetCurrentAssignments`);
  }

  endAssignment(customerId: number, userId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/EndAssignment`, {
        customerId: customerId,
        userId: userId
    });
  }

  getQueueSize(partnerUserId: number): Observable<number> {
    const params = new HttpParams().set('partnerUserId', partnerUserId);

    return this.http.get<number>(`${this.baseUrl}/GetQueueSize`, { params: params });
  }
}
